import CloseIcon from "@mui/icons-material/Close";
import {
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import * as React from "react";
import { connect } from "react-redux";
import { LabelCompo } from "../../components/Comman/Label";

import { ButtonCompo } from "../../components/Comman/Button";
import { blackColor, checkboxColor } from "../../config/ColorObj";
import NoDataFound from "../DashbourdChanges/NoDataFound";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const BootstrapDialogTitle = (props) => {
    const { classes, children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const TimelinePopUp = ({
    handleCloses,
    open,
    listData,
}) => {
    console.log(listData)
    const handleClose = () => {
        handleCloses();
    };
    return (
        <>
            <Paper sx={{ p: 3, pt: 2, borderRadius: 2 }} elevation={0}>
                <BootstrapDialog
                    onClose={handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={open}
                    fullWidth
                    maxWidth="lg"
                >
                    <BootstrapDialogTitle
                        id="customized-dialog-title"
                        onClose={handleClose}
                    >
                        Timeline
                    </BootstrapDialogTitle>
                    <DialogContent dividers>

                        <Grid
                            item
                            sm={12}
                            xs={12}
                            md={12}
                            lg={12}
                            container
                            sx={{ p: 2 }}
                            justifyContent="space-evenly"
                        >
                            <Grid item xs={12} sm={12} md={2}>
                                <LabelCompo
                                    className="text-black"
                                    style={{ fontSize: 16 }}
                                    label="Date : "
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={4}>
                                <LabelCompo
                                    className="text-black"
                                    style={{ fontSize: 16 }}
                                    label={listData.length !== 0 ? listData[0].date : "-"}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={2}>
                                <LabelCompo
                                    className="text-black"
                                    style={{ fontSize: 16 }}
                                    label="Sales Person Name : "
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={4}>
                                <LabelCompo
                                    className="text-black"
                                    style={{ fontSize: 16 }}
                                    label={listData.length !== 0 ? listData[0].salesTeamName : "-"}
                                />
                            </Grid>
                        </Grid>
                        <DialogContent>
                            {listData.length != 0 ? (
                                <>
                                    <TableContainer>
                                        <Table stickyHeader aria-label="sticky table">
                                            <TableHead>
                                                <TableRow>
                                                    {localStorage.getItem("showTimelineManagerLogsWise")
                                                        && localStorage.getItem("showTimelineManagerLogsWise") == 1 ? (
                                                        <>
                                                            <TableCell align="center" sx={{ width: "3%" }}>
                                                                Sr. No
                                                            </TableCell>
                                                            <TableCell align="center" sx={{ width: "15%" }}>
                                                                Working Type
                                                            </TableCell>
                                                            <TableCell align="center" sx={{ width: "15%" }}>
                                                                Task Name
                                                            </TableCell>
                                                            <TableCell align="center" sx={{ width: "35%" }}>
                                                                Outlet Name
                                                            </TableCell>
                                                            <TableCell align="center" sx={{ width: "30%" }}>
                                                                Amount / Reason
                                                            </TableCell>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <TableCell align="center" sx={{ width: "3%" }}>
                                                                Sr. No
                                                            </TableCell>
                                                            <TableCell align="center" sx={{ width: "35%" }}>
                                                                Outlet Name
                                                            </TableCell>
                                                            <TableCell align="center" sx={{ width: "30%" }}>
                                                                Amount
                                                            </TableCell>
                                                        </>
                                                    )}

                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {listData.map((matrixDataRow, indexRow) => {

                                                    return (

                                                        <TableRow>
                                                            {localStorage.getItem("showTimelineManagerLogsWise")
                                                                && localStorage.getItem("showTimelineManagerLogsWise") == 1 ? (
                                                                <>
                                                                    <TableCell width="10%" align="center">
                                                                        {indexRow + 1}
                                                                    </TableCell>
                                                                    <TableCell>{matrixDataRow.workingTypeName}</TableCell>
                                                                    <TableCell>{matrixDataRow.otherTaskName}</TableCell>
                                                                    <TableCell>{matrixDataRow.firmName}</TableCell>
                                                                    <TableCell>{matrixDataRow.reason}</TableCell>
                                                                </>

                                                            ) : (
                                                                <>
                                                                    <TableCell width="10%" align="center">
                                                                        {indexRow + 1}
                                                                    </TableCell>
                                                                    <TableCell>{matrixDataRow.outletName}</TableCell>
                                                                    <TableCell align="right">{Number(matrixDataRow.amount).toFixed(2)}</TableCell>

                                                                </>
                                                            )}

                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                </>
                            ) : (<NoDataFound />)}

                            <br />
                        </DialogContent>
                    </DialogContent>

                </BootstrapDialog>
            </Paper>
        </>
    );
};
const mapStateToProps = (state) => ({
    beatList: state.beat,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(TimelinePopUp);
